module.exports = __webpack_public_path__ + "static/media/icon-github.8d60a76c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-github.svg
// module id = 511
// module chunks = 0